import axios            from "axios";
import store            from "@/store";

export const getReportPermissions = async (params) => {
  try {
    const baseUrl = window.VUE_APP_SIMPRA_REPORTS_API_URL || process.env.VUE_APP_SIMPRA_REPORTS_API_URL;
    const token = store.getters['Auth/Token'].value

    const res = await axios.get(`${baseUrl}/api/report-permission`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      params,
    });
    return res.data;
  } catch (error) {
    console.error("Error fetching reports data:", error);
    throw error;
  }
};

export const editReportPermissions = async (payload) => {
  try {
    const baseUrl = window.VUE_APP_SIMPRA_REPORTS_API_URL || process.env.VUE_APP_SIMPRA_REPORTS_API_URL;
    const token = store.getters['Auth/Token'].value

    const res = await axios.post(`${baseUrl}/api/report-permission`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
    return res.data;
  } catch (error) {
    console.error("Error editing reports data:", error);
    throw error;
  }
};
